import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router';
import { type ReactNode } from 'react';

const DesktopIconContainer = styled(Box)(({ theme }) => ({
  width: 96,
  height: 96,
  textAlign: 'center',
  color: theme.palette.text.primary,
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),
  '& svg': {
    width: 48,
    filter: 'drop-shadow(0 0 2px rgba(125,211,199,0.4))',
  },
  '&:hover': {
    color: theme.palette.secondary.main,
  },
}));

export const DesktopIcon = ({
  label,
  icon,
  to,
  href,
}: {
  label: string;
  icon: ReactNode;
  to?: string;
  href?: string;
}) => {
  const nav = useNavigate();

  const handleClick = () => {
    if (to) {
      nav(to);
    } else if (href) {
      window.open(href, '_self');
    }
  };

  const labelStyles = {
    color: 'inherit',
    textDecoration: 'none',
  };

  return (
    <DesktopIconContainer role="button" onClick={handleClick}>
      {icon}
      <Typography sx={labelStyles} variant="caption">
        {label}
      </Typography>
    </DesktopIconContainer>
  );
};
